
import { hostImg } from "../../../callApi/AxiosCall";
import { getPostDetailApi } from "../../../callApi/postApi";
import { getProductApi, getProductDetailApi } from "../../../callApi/productApi";
import CustomBottom from "../../../components/CustomBottom";
import CustomButton from "../../../components/CustomButton";
import CustomHeader from "../../../components/CustomHeader";
import CustomInput from "../../../components/CustomInput";
import CustomPagination from "../../../components/CustomPagination";
import html2canvas from "html2canvas";
import React, { useEffect, useRef, useState } from "react";
import QRCode from "react-qr-code";
import ReactToPrint from "react-to-print";
import parse from 'html-react-parser';
import { useNavigate, useParams } from "react-router-dom";

export default function BlogID() {
  const [postItem, setpostItem] = useState(null);
  const [postContent, setpostContent] = useState(null)

  const router = useNavigate();
  const params = useParams();
  const PrintRef = useRef();

  useEffect(() => {
    if (params.id != null) {
      callpost();
    }
  }, [params]);

  const callpost = async () => {
    let res = await getPostDetailApi({ post_id: params.id });
    if (res?.status == 200) {
      setpostItem(res.data.data);
      setpostContent(JSON.parse(res.data.data.content).html);

    }
  };
  const QRData = () => {
    return (
      <div 
      className="absolute -z-50 opacity-0"
      >
        <div ref={PrintRef}  className="w-[300px] h-[300px] p-3 flex flex-col items-center text-xl bg-white ">
          <QRCode
            size={256}
            style={{ height: "auto", maxWidth: "100%", width: "100%" }}
            value={'https://ftcdc-udru-qqp4p.ondigitalocean.app/'+'/circular-design/'+ params?.id}
            viewBox={`0 0 256 256`} 
          />
          {/* {window.location.hostname+'/circular-design/'+ params?.id} */}
              <p className="font-medium ">{postItem?.no ?? ""}</p>
              <p className="font-bold ">{postItem?.name}</p>
        </div>
      </div>
    );
  };

  const handleDownloadImage = async() => {
    // const element = document.getElementById('printQR')
    const canvas = await html2canvas(PrintRef.current, {
      allowTaint: true,
      useCORS: true,
      backgroundColor: "white",
      removeContainer: true,
    })
    const data = canvas.toDataURL('image/jpeg')
    const link = document.createElement('a');
    link.href = data;
    link.download = postItem?.name+'-qr-image.jpg';
    // document.body.appendChild(link);
    link.click();
    link.remove();
    // document.body.removeChild(link);
  };
  return (
    <div className="fade_In">
      <CustomHeader />

      <div className="flex flex-row items-center gap-4  pt-[180px]">
        <div className="  absolute left-[10vw]">
          <p className="font-medium text-[20px] text-[#B36427]">
          ข่าวและกิจกรรม
          </p>
          <p className="font-bold text-[32px] md:text-[64px]">NEWS & EVENT</p>
        </div>
        <img src="/img/bgGreen.png" className="w-full object-contain" />
      </div>
      <div className="px-[10vw] py-[24px] flex flex-col items-center ">
        <div
          onClick={() => {
            router(-1);
          }}
          className="flex  items-center gap-4 w-full hover:cursor-pointer"
        >
          <img
            src={"/img/arrowLeft3.png"}
            className="w-[40px] h-[40px] object-contain drop-shadow-md"
          />
          <p className="text-base md:text-[32px] font-bold text-[#B36427]">
            {postItem?.title}
          </p>
        </div>
        
        <div className="mt-5 mb-5 w-full flex flex-col items-center gap-3 w-full">
          {postContent?.map((item, i) => {
            return (
              <div key={i} className="grid grid-flow-col gap-3 w-full">
                {item?.map((data, j) => {
                  if (data.type == "text")
                    return (
                      <div
                        key={j}
                        className="rounded-lg py-2 bg-white drop-shadow-sm w-full"
                        // dangerouslySetInnerHTML={{ __html: data.value }}
                      >
                        {parse(data.value)}
                      </div>
                    );
                  if (data.type == "image")
                    return (
                      <div
                        key={j}
                        className="flex-1 flex flex-col items-center"
                      >
                        <img
                          src={
                            // "https://upload.wikimedia.org/wikipedia/en/thumb/e/e2/IMG_Academy_Logo.svg/800px-IMG_Academy_Logo.svg.png"
                            "https://ftcdc.udru.ac.th/ftcdc-api/storage/app/public/upload/UploadImg/" +
                            data.value
                          }
                          className="object-cover rounded-lg"
                        />
                      </div>
                    );
                  return <div className="flex-1"></div>;
                })}
              </div>
            );
          })}
        </div>
        <QRData />
      </div>
      <CustomBottom />
    </div>
  );
}
